// extracted by mini-css-extract-plugin
module.exports = {"listTitle":"CardInfo_listTitle_COg-O"};